import { render, staticRenderFns } from "./index.vue?vue&type=template&id=480dce24&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=480dce24&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480dce24')) {
      api.createRecord('480dce24', component.options)
    } else {
      api.reload('480dce24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=480dce24&lang=pug", function () {
      api.rerender('480dce24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/memberClassRecords/classRecordsTable/index.vue"
export default component.exports